module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('TableFilter', {
    attrs: {
      "columns": _vm.columnFilterHeaders
    },
    on: {
      "search": _vm.onSearch
    }
  }), _vm._v(" "), _c('v-data-table', {
    key: "table",
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "item-value": "id"
    },
    on: {
      "contextmenu": function($event) {
        $event.preventDefault();
        return _vm.onRightClick.apply(null, arguments)
      }
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          attrs: {
            "small": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.confirmDeleteUser(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "color": "grey darken-4"
          }
        }, [_vm._v("mdi-delete")])], 1)]
      }
    }, {
      key: "item.roles",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-select', {
          key: item.id + '-' + item.roles,
          attrs: {
            "items": _vm.rolesList,
            "item-value": "id",
            "item-text": "name",
            "placeholder": "Select...",
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "menu-props": {
              closeOnContentClick: true
            },
            "mulitple": "false"
          },
          on: {
            "change": function($event) {
              return _vm.onRoleChange(item)
            }
          },
          model: {
            value: (item.roles),
            callback: function($$v) {
              _vm.$set(item, "roles", $$v)
            },
            expression: "item.roles"
          }
        })]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e3c5a48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/permissions/components/UserList.vue
// module id = 1889
// module chunks = 0